/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_TitleInputs */

const en_vc_ft_title = /** @type {(inputs: Vc_Ft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Illustrator tools you already know`)
};

const zh_vc_ft_title = /** @type {(inputs: Vc_Ft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你熟悉的 Illustrator 工具，都在这里`)
};

/**
* | output |
* | --- |
* | "The Illustrator tools you already know" |
*
* @param {Vc_Ft_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_title = /** @type {((inputs?: Vc_Ft_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_title(inputs)
	return zh_vc_ft_title(inputs)
});
export { vc_ft_title as "vc.ft.title" }